<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">POLICY</div>
          <div class="eng-font">政策标准</div>
        </div>

        <div
          :class="pindex == index ? 'column2' : 'column1'"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div @click="categoryChange(index)">{{ item.name }}</div>
          <div v-if="pindex == index" style="float: right; margin-right: 20px">
            >
          </div>
        </div>
      </div>

      <div class="certificate-list-right">
        <div class="titleList">
          <div
            class="title"
            v-for="(item, index) in titleList"
            :key="index"
            @mouseenter="enter(index)"
            @mouseleave="leave()"
            @click="toDetail(index)"
          >
            <div :class="styleFlag == index ? 'title-left2' : 'title-left1'">
              {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
            </div>
            <div class="title-right">
              <div class="title-title">{{ item.name }}</div>
              <div class="title-brief">{{ item.brief }}</div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="title-page">
          <!-- 如果只有一页 不显示页码及下一页 -->
          <!-- <div v-if="page.pageCount>1"> -->
          <div class="flex">
            <div
              v-for="index of page.pageCount"
              class="box"
              :class="pageIndex == index ? 'active' : ''"
              @click="pagetap(index)"
            >
              {{ index }}
            </div>
          </div>
          <div
            class="box title-page-active"
            @click="pageto()"
            style="width: 150px"
          >
            下一页
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../../services/article";
export default {
  components: {},
  data() {
    return {
      pindex: 0,
      pageIndex: 1,
      styleFlag: -1,
      dataList: [],
      titleList: [],
      page: {
        totalCount: 0, //总记录数
        pageCount: 1, //总页数
        currentPage: 0, //当前页
        perPage: 8, //每页显示数量
      },
      menuList: [
        {
          id: "137",
          name: "政策标准",
          path: "/certificatechildren",
        },
        {
          id: "138",
          name: "通知公告",
          path: "/notice",
        },
        {
          id: "139",
          name: "师资培训",
          path: "/train",
        },
        {
          id: "140",
          name: "教学资源",
          path: "/resource",
        },
        {
          id: "141",
          name: "证书信息",
          path: "/certificateInfo",
        },
        {
          id: "142",
          name: "学分银行",
          path: "/creditbank",
        },
        {
          id: "143",
          name: "信息查询",
          path: "/inqure",
        },
      ],
    };
  },

  created() {
    // this.menuClick(0);
  },
  // watch: {'$route':"fetchData"},
  mounted() {
    this.menuClick(0);
  },
  methods: {
    //一级分类标题点击事件 : 根据pid查询cid
    menuClick(index) {
      this.searchFlag = true;
      this.searchImgUrl = "";
      this.sourceFlag = true;
      this.pageIndex = 1; //初始化页码
      this.activeName = index; //改变选项卡样式
      this.pindex = 0; //改变二级菜单样式
      // 学分银行不执行
      if (index == 5 || index == 4 || index == 6) {
        this.dataList = [];
        return;
      }
      
      let dataList = [];
      this.dataList = [];
      let pid = this.menuList[index].id;
      //console.log(this.menuList, "res1");
      //获取二级分类
      ArChildren({
        pid: pid,
      }).then((res1) => {
        //console.log(res1, "res1");
        if (res1.items.length > 0) {
          this.dataList = [];
          res1.items.forEach((item) => {
            dataList.push(item);
          });
          //这里接口跨域，this.dataList获取不到值
          this.dataList = dataList;
          //console.log(dataList, "dataList");
          let cid = this.dataList[0].id;
          //获取二级分类下的文章列表
          if (index != 2) {
            this.article(cid, 1);
          }
        }
      });
      // }
    },

    //根据cid查询文章列表
    categoryChange(index) {
      //根据tab页面切换，展示不同页面
      this.tabChangeNum = index;
      //初始化searchStyle值
      this.searchStyle1 = 1;
      this.searchStyle2 = 0;
      this.searchImgUrl = "";
      this.searchFlag = true;

      //console.log(index, `tab切换，现在切换到${index}`);

      this.sourceFlag = true; // 恢复教学资源显示的初始布局
      this.pindex = index; //修改二级分类菜单样式控制参数
      this.pageIndex = 1; //初始化页码
      let cid = this.dataList[index].id;
      this.article(cid, 1);
    },
    article(cid, page) {
      this.titleList = [];
      let titleList = [];
      Article({
        category_id: cid,
        page_size: 8,
        page: page,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList = titleList;
          //处理分页
          this.page.totalCount = res2._meta.totalCount;
          this.page.pageCount = res2._meta.pageCount;
          this.page.currentPage = res2._meta.currentPage;
        }
      });
    },
    //鼠标悬浮事件-修改文章标题样式
    enter(index) {
      this.styleFlag = index;
    },
    //鼠标离开事件-修改文章标题样式
    leave() {
      this.styleFlag = -1;
    },
    // 文章点击跳转文章详情页
    toDetail(index) {
      if (this.titleList[index].content.length < 100) {
        window.open(this.titleList[index].attachment, "_blank");
        return;
      }
      this.$router.push({
        path: "/certificate-active",
        query: {
          id: this.titleList[index].id,
          category_id: this.titleList[index].category_id,
        },
      });
      // 修改公告标题样式风格
      this.leave();
    },
    // 翻页方法
    pagetap(page) {
      let cid = 0;
      this.pageIndex = page; //更新页码样式控制参数
      if (this.activeName == 2) {
        cid = this.menuList[2].id;
      } else {
        cid = this.dataList[this.pindex].id;
      }
      this.article(cid, page);
    },
    // 下一页方法
    pageto() {
      let cid = 0;
      //更新页码样式控制参数
      if (this.pageIndex == this.page.pageCount) {
        this.pageIndex = 1;
      } else {
        this.pageIndex = this.pageIndex + 1;
      }
      //获取cid
      if (this.activeName == 2) {
        cid = this.menuList[2].id;
      } else {
        cid = this.dataList[this.pindex].id;
      }
      this.article(cid, this.pageIndex);
    },
  },
};
</script>

<style>
.partner {
  background-color: white;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #EEEEEE;
}
.certificate-list-left {
  float: left;
  width: 185px;
  /* min-height: 450px; */
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}

.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}
.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}
.titleList {
  height: auto;
  width: auto;
  margin-top: 30px;
}
.title {
  display: flex;
  margin-left: 50px;
  width: auto;
  height: 85px;
}
.title:hover {
  background-color: #0055d3;
  color: #e6e6e6;
  cursor: pointer;
}
.title-left1 {
  color: #0055d3;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-left2 {
  color: #e6e6e6;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-right {
  height: auto;
  padding-top: 13px;
  margin-left: 12px;
  vertical-align: middle;
  line-height: 30px;
}
.title-title {
  font-size: 18px;
  font-weight: bold;
}

.title-brief {
  font-size: 14px;
}
.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}

.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}

.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
</style>